import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-ff831a26")
const _hoisted_1 = {
  key: 0,
  ref: "onBoardingSaveContinueRef"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Continue  ")
const _hoisted_3 = {
  key: 1,
  "aria-label": "Save and continue to review",
  class: "btn save-continue",
  style: {"opacity":".4"},
  disabled: ""
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_ctx.labelType !== 'blank')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              id: "save-continue",
              class: "btn save-continue",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveAndContinue && _ctx.saveAndContinue(...args)))
            }, [
              _hoisted_2,
              _createVNode(_component_font_awesome_icon, {
                icon: "arrow-alt-circle-right",
                "aria-hidden": "true"
              })
            ]))
          : (_openBlock(), _createElementBlock("button", _hoisted_3, " Saving . . . "))
      ], 512))
    : _createCommentVNode("", true)
}